import { ItemUnit } from '@backend/domain'
import { ApiProperty, ApiPropertyOptional, PickType } from '@nestjs/swagger'
import {
	ArrayMinSize,
	IsArray,
	IsBoolean,
	IsEnum,
	IsNotEmpty,
	IsNumber,
	IsOptional,
	IsPositive,
	IsString,
	IsUUID,
	Length,
	MaxLength,
} from 'class-validator'

export class MenuItemCategoryResponse {
	@ApiProperty({ type: String, format: 'uuid' })
	categoryId: string

	@ApiProperty({ type: Number })
	sortOrder: number

	@ApiProperty({ type: Boolean })
	isVisible: boolean
}

export class MenuItemCategoryRequest {
	@ApiProperty({ type: String, format: 'uuid' })
	@IsNotEmpty()
	@IsUUID()
	categoryId: string

	@ApiProperty({ type: Number, minimum: 1 })
	@IsNotEmpty()
	@IsNumber()
	@IsPositive()
	sortOrder: number
}

export class MenuItemResponse {
	@ApiProperty({ type: String, format: 'uuid' })
	id: string

	@ApiProperty({ type: String })
	name: string

	@ApiPropertyOptional({ type: String })
	description?: string

	@ApiProperty({ type: Number })
	price: number

	@ApiProperty({ type: String })
	currency: string

	@ApiProperty({ type: Number })
	amount: number

	@ApiProperty({ enum: ItemUnit })
	unit: ItemUnit

	@ApiPropertyOptional({ type: String, isArray: true })
	allergens?: string[]

	@ApiPropertyOptional({ type: String })
	coverUrl?: string

	@ApiProperty({ type: Boolean })
	isArchived: boolean

	@ApiProperty({ type: MenuItemCategoryResponse, isArray: true })
	categories: MenuItemCategoryResponse[]

	@ApiPropertyOptional({ type: MenuItemCategoryResponse, isArray: true })
	subcategories?: MenuItemCategoryResponse[]
}

export class CreateMenuItemRequest {
	@ApiProperty({ type: String, minLength: 2, maxLength: 60 })
	@IsNotEmpty()
	@IsString()
	@Length(2, 60)
	name: string

	@ApiPropertyOptional({ type: String, maxLength: 255 })
	@IsOptional()
	@IsNotEmpty()
	@IsString()
	@MaxLength(255)
	description?: string

	@ApiProperty({ type: Number })
	@IsNotEmpty()
	@IsNumber()
	@IsPositive()
	price: number

	@ApiProperty({ type: String })
	@IsNotEmpty()
	@IsString()
	@Length(3, 3)
	currency: string

	@ApiProperty({ type: Number })
	@IsNotEmpty()
	@IsNumber()
	@IsPositive()
	amount: number

	@ApiProperty({ enum: ItemUnit })
	@IsNotEmpty()
	@IsEnum(ItemUnit)
	unit: ItemUnit

	@ApiPropertyOptional({ type: String, isArray: true })
	@IsOptional()
	@IsArray()
	allergens?: string[]

	@ApiPropertyOptional({ type: String })
	@IsOptional()
	@IsNotEmpty()
	@IsString()
	coverUrl?: string

	@ApiProperty({ type: MenuItemCategoryRequest, isArray: true })
	@IsNotEmpty()
	@IsArray()
	@ArrayMinSize(1)
	categories: MenuItemCategoryRequest[]

	@ApiPropertyOptional({ type: MenuItemCategoryRequest, isArray: true })
	@IsOptional()
	@IsArray()
	subcategories?: MenuItemCategoryRequest[]
}

export class UpdateMenuItemRequest extends CreateMenuItemRequest {
	@ApiProperty({ type: String, format: 'uuid' })
	@IsNotEmpty()
	@IsUUID()
	id: string
}

export class ImportMenuItemRequest extends PickType(CreateMenuItemRequest, [
	'name',
	'description',
	'price',
	'currency',
	'amount',
	'unit',
]) {
	@ApiProperty({ type: String, isArray: true })
	@IsNotEmpty()
	@IsArray()
	@ArrayMinSize(1)
	categories: string[]
}

export class ToggleArchiveRequest {
	@ApiProperty({ type: Boolean })
	@IsNotEmpty()
	@IsBoolean()
	isArchived: boolean
}

export class ToggleVisibleRequest {
	@ApiProperty({ type: Boolean })
	@IsNotEmpty()
	@IsBoolean()
	isVisible: boolean
}
